import { IntegerStepperWidget } from '@tableau/widgets';
import React from 'react';

import { ReactActionDialogBodyProps } from '../../commonInfra/dialogs/ReactActionDialog';

export type ChangePriorityDialogProps = {
  readonly description: string;
  readonly numberDescription: string;
  readonly min: number;
  readonly max: number;
  readonly isInteger: boolean;
  readonly title: string;
}

export type ChangePriorityDialogState = {
  readonly text: number;
  readonly errorMessage?: string;
}
export function ChangePriorityDialogBody(props: ReactActionDialogBodyProps<ChangePriorityDialogProps, ChangePriorityDialogState>): JSX.Element {
  const onChange = (value: number) => {
    props.updateDialogState({ errorMessage: undefined, text: value });
  };

  return (
    <>
      <div className="tb-dialog-title">{props.title}</div>
      <div className='tb-dialog-body-input-description'>
        { props.description }
      </div>
      <div className='tb-dialog-body-input'>
        <IntegerStepperWidget
          containerStyle={{width: '75px'}}
          label=''
          max={props.max}
          min={props.min}
          start={props.dialogState.text}
          disabled={props.actionBusy}
          onValueUpdated={(value: number) => {onChange(value);}}
          testId=''
          shouldSelectTextOnFocus={false}
        />
      </div>
      { props.numberDescription }
    </>
  );
}



